<mat-card class="p-0">
    <mat-card-header>
        <mat-card-title *ngIf="type =='renting'  && rentings">
            Location en attente
        </mat-card-title>
        <mat-card-title *ngIf="type =='user' && users">
            Liste des utiliateurs Bloqués
        </mat-card-title>
        <mat-card-title *ngIf="type =='car' && cars">
            Liste des Véhicules Indisponibles
        </mat-card-title>
    </mat-card-header>
    <div class="mat-table theme-table header-sm truncated" *ngIf="type =='renting' && rentings">
        <div class="mat-header-row">
            <div class="mat-header-cell" *ngFor="let column of columns">{{column}}</div>
        </div>
        <div *ngFor="let renting of rentings" class="mat-row">
           <div class="mat-cell"><span class="order">{{ renting.renting_date_departure | date |titlecase}}</span></div>
            <div class="mat-cell">{{renting.renting_date_return| date |titlecase}}</div>
            <div class="mat-cell">{{renting.renting_price_location}} {{appService.getCurrency()}}</div>   
            <div class="mat-cell">
                <span *ngIf="renting.renting_status == 'EN_ATTENTE'" style="color: blue;">En attente de Validation</span>
                <span *ngIf="renting.renting_status == 'VALIDER'" style="color: rgb(3, 154, 3);">Validée</span>
            </div>
            <div class="mat-cell">
                <div class="p-1 actions">          
                    <button mat-icon-button color="primary" matTooltip="View" (click)="viewRenting(renting.id)">
                        <mat-icon>remove_red_eye</mat-icon>
                    </button>
                </div>
            </div>    
        </div>
    </div>
    <div class="mat-table theme-table header-sm truncated" *ngIf="type =='user' && users">
        <div class="mat-header-row">
            <div class="mat-header-cell" *ngFor="let column of columns">{{column}}</div>
        </div>
        <div *ngFor="let user of users" class="mat-row">
            <div class="mat-cell"><span class="order">{{user.user_name}}</span></div>
            <div class="mat-cell">{{user.email}}</div>
            <div class="mat-cell">{{user.user_phone}}</div>
            <div class="mat-cell">{{user.user_city}}</div>     
            <div class="mat-cell">
                <div class="p-1 actions">          
                    <button mat-icon-button color="primary" matTooltip="View" (click)="listUser()">
                        <mat-icon>remove_red_eye</mat-icon>
                    </button>
                </div>
            </div>    
        </div>
    </div>
    <div class="mat-table theme-table header-sm truncated" *ngIf="type =='car' && cars">
        <div class="mat-header-row">
            <div class="mat-header-cell" *ngFor="let column of columns">{{column}}</div>
        </div>
        <div *ngFor="let car of cars" class="mat-row">
           <div class="mat-cell"><span class="order">{{car.mark_lib}}</span></div>
            <div class="mat-cell">{{car.mod_lib}}</div>
            <div class="mat-cell">{{car.vehicle_price_location}}</div>
            <div class="mat-cell">{{car.status}}</div>     
            <div class="mat-cell">
                <div class="p-1 actions">          
                    <button mat-icon-button color="primary" matTooltip="View" (click)="showCar(car.id )">
                        <mat-icon>remove_red_eye</mat-icon>
                    </button>
                </div>
            </div>    
        </div>
    </div>
</mat-card>